import classNames from "classnames";
import Section from "./Section";
import { useSearchParams } from "react-router-dom";

type Tab = {
  label: string;
  value: string;
};
type BoolTabsProps = {
  defaultTab: Tab;
  alternateTab: Tab;
  onChange: (value: string) => void;
};
const BoolTabs = ({ defaultTab, alternateTab, onChange }: BoolTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get("tab") ?? defaultTab.value;

  return (
    <Section>
      <div className="flex text-sm">
        <button
          className={classNames("p-2 flex-1 border-b", {
            "font-bold border-b-gray-900": defaultTab.value === value,
          })}
          onClick={() => {
            if (value === defaultTab.value) return;

            setSearchParams((params) => {
              params.delete("tab");
              params.delete("p");
              return params;
            });

            onChange(defaultTab.value);
          }}
        >
          {defaultTab.label}
        </button>

        <button
          className={classNames("p-2 flex-1 border-b", {
            "font-bold border-b-gray-900": alternateTab.value === value,
          })}
          onClick={() => {
            if (value === alternateTab.value) return;

            setSearchParams((params) => {
              params.set("tab", alternateTab.value);
              params.delete("p");
              return params;
            });

            onChange(alternateTab.value);
          }}
        >
          {alternateTab.label}
        </button>
      </div>
    </Section>
  );
};

export default BoolTabs;
